import $ from 'jquery';
import showTemplateFlash from '../util/show_template_flash';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  const addTaxRate = ({ currentTarget }) => {
    const selector = currentTarget.getAttribute('data-template');
    const placeholder = currentTarget.getAttribute('data-child-placeholder');
    const template = $(selector)[0].content.children[0].cloneNode(true);
    const randomIndex = new Date().getTime();

    template.querySelectorAll('input').forEach((element) => {
      element.id = element.id.replace(placeholder, randomIndex);
      element.name = element.name.replace(placeholder, randomIndex);
    });

    $(currentTarget).parents('table').find('tbody').append(template);
    $(template).find('td:first input').focus();
  };
  $(document).on('click', '[data-button="sales-tax--add-tax-rate"]', addTaxRate);

  const removeTaxRate = ({ currentTarget }) => {
    const $tr = $(currentTarget).parents('tr');
    const $destroy = $tr.find('[data-tax-rate-field="destroy"]');

    if ($destroy.length) {
      $destroy.val('1');
      $tr.hide();
    } else {
      $tr.remove();
    }
  };
  $(document).on('click', '[data-button="sales-tax--remove-tax-rate"]', removeTaxRate);

  const calculateTotalSalesTaxRate = () => {
    let total = 0.0;
    $('.field--rate:visible').each((_index, e) => {
      total += parseFloat($(e).val()) || 0;
    });
    $('.tax-rates-table__total').text(total.toFixed(3) * 1);
  };

  $(document).on('keypress', '.tax-rates-table__item-td--rate', (e) => {
    const oldVal = e.target.value;
    const newVal = `${oldVal}${String.fromCharCode(e.which)}`;
    if (newVal.split('.').length > 1) {
      const decimals = newVal.split('.')[1].length;
      if (decimals > 3) {
        return false;
      }
    }
  });

  $(document).on('change keyup paste input', '.field--rate', (e) => {
    calculateTotalSalesTaxRate();
  });

  $(document).on('click', '.tax-rates-table__remove-tax-rate-link', (e) => {
    calculateTotalSalesTaxRate();
  });

  $(document).on('change keyup paste input', '.tax-rates-table__item-td input', (e) => {
    if ($(e.target).hasClass('tax-rates-table__item-td--error')) {
      $(e.target).removeClass('tax-rates-table__item-td--error');
    }
  });

  $(document).on('submit', '.sales-tax-form', (e) => {
    e.preventDefault();
    const $form = $(e.target);
    const $submit = $form.find('button[type=submit]');
    const url = $form.attr('action');
    const method = $form.attr('id') === 'new_sales_tax' ? 'POST' : 'PATCH';

    // client side validation for tax-rates-table
    $form
      .find('.tax-rates-table')
      .find('tbody tr:visible td input')
      .each((_index, el) => {
        if ($(el).val().length === 0) {
          $(el).addClass('tax-rates-table__item-td--error');
        }
      });

    if ($('.tax-rates-table__item-td--error').length) {
      return false;
    }

    $submit.addClass('button-loading').prop('disabled', true);
    $.ajax({
      type: method,
      url,
      data: $form.serialize(),
      success: (data) => {
        if ($('body').is('#settings-sales-taxes')) {
          if (method === 'PATCH') {
            // remove existing row and add updated row in top of table; sort_by: updated_at desc
            $('.data-table__table tbody').find(`tr[data-id="${data.sales_tax.id}"]`).remove();
          }

          $(data['partial']).prependTo('.data-table__table tbody');
          if (document.body.hasAttribute('data-sidenav-layout')) {
            showTemplateFlash('sales-tax-notice', data.notice);
          } else if ($('.main').find('.flash--notice').length) {
            $('.flash--notice').text(data.notice);
          } else {
            $('.main').prepend(`<div class="flash flash--notice">${data.notice}</div>`);
          }
        } else if ($('body').is('#invoices-edit')) {
          appendSalesTaxOption(
            'field--billable-sales-tax',
            data,
            $('.h-s-button--invoice-add-sales-tax')
          );
        } else if ($('body').is('#quotes-edit')) {
          appendSalesTaxOption(
            'field--billable-sales-tax',
            data,
            $('.h-s-button--quote-add-sales-tax')
          );
        } else if ($('body').is('#purchase-orders-edit')) {
          appendSalesTaxOption(
            'field--billable-sales-tax',
            data,
            $('.h-s-button--purchase-order-add-sales-tax')
          );
        } else if ($('body').is('#design-packages-form')) {
          $('.select-field--design-package-sales-tax').each((_, e) => {
            $(e)
              .find('option:last')
              .before(
                $('<option />')
                  .text(`${data.sales_tax.rate}% - ${data.sales_tax.name}`)
                  .val(data.sales_tax.id)
                  .attr('data-tax-rate', data.sales_tax.rate)
              );
          });
          $('.select-field--design-package-sales-tax.active-select')
            .val(data.sales_tax.id)
            .change();
        }
        $('.close-modal').click();
      },
      error: (data) => {
        const errors = data.responseJSON.errors;
        for (const key in errors) {
          const $errorLabelSelector = $form.find(`#${key}`);
          if ($errorLabelSelector) {
            $errorLabelSelector.text(errors[key]).show();
          }
        }
        $submit.removeClass('button-loading').prop('disabled', false);
      },
    });
  });

  const appendSalesTaxOption = (selectClass, data, $addSalesTaxBtnSelector) => {
    if ($(`.${selectClass}`).length) {
      $(`.${selectClass} option:last`).before(
        $('<option />')
          .text(`${data.sales_tax.rate}% - ${data.sales_tax.name}`)
          .val(data.sales_tax.id)
          .attr('data-tax-rate', data.sales_tax.rate)
      );
      $(`.${selectClass}`).val(data.sales_tax.id).change();
    } else {
      const $selectSalesTax = $(`<select class="field ${selectClass}"></select>`);
      $selectSalesTax.append(
        $('<option />')
          .text(`${data.sales_tax.rate}% - ${data.sales_tax.name}`)
          .val(data.sales_tax.id)
          .attr('data-tax-rate', data.sales_tax.rate)
      );
      $selectSalesTax.append($('<option />').text('+ Add Sales Tax').val('add_sales_tax'));
      $addSalesTaxBtnSelector.replaceWith($selectSalesTax);
    }
  };
});
